import MAYA from '../../../maya_api'
import {setLoadingContent} from "../../../layouts/Content/modules/loadingContent";

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
const SELECT_CATEGORY = 'SELECT_CATEGORY';

// ------------------------------------
// Actions
// ------------------------------------
function loadCategories() {
  return async (dispatch) => {

    dispatch(setLoadingContent(true));

    const categories = await MAYA.getCategories();

    dispatch(setLoadingContent(false));

    dispatch({
      type    : LOAD_CATEGORIES,
      payload : categories
    });
  };
}

function selectCategory(value) {
  return {
    type    : SELECT_CATEGORY,
    payload : value
  }
}

export {
  loadCategories,
  selectCategory
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOAD_CATEGORIES]: (state, action) => ({
    ...state,
    list: action.payload
  }),
  [SELECT_CATEGORY]: (state, action) => ({
    ...state,
    selectedCategory: action.payload
  })
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  selectedCategory: null,
  list: [],
};

export default function categoriesReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/Categories/modules/categories.js